<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees class="row my-5"> </app-nav-gestion-donnees>

	<div *ngIf="employee" class="row my-3 theme-main-color">
		<div class="row">
			<div class="d-flex justify-content-between">
				<div class="hand-cursor">
					<span (click)="goBack()" class="fs-4"
						><i class="bi bi-arrow-left me-3" aria-hidden="true"></i
						>{{ employee.firstName }} {{ employee.lastName }}</span
					>
				</div>

				<div *ngIf="isDeletable" class="">
					<a
						(click)="openConfirmDeleteModal(deleteEmployee)"
						class="btn theme-red-button px-4"
					>
						Supprimer la fiche
					</a>
				</div>
			</div>
			<div class="row my-5">
				<span class="fw-bold fs-5">Informations</span>
			</div>
		</div>
		<div class="rounded bg-light">
			<app-employee-form
				*ngIf="!isFormReadOnly"
				[employee]="employee"
				[isAddForm]="false"
				[form]="employeeDetailForm"
				[isAddressSelected]="isAddressSelected"
				[isAddressDefault]="isAddressDefault"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
			></app-employee-form>
			<div *ngIf="isFormReadOnly">
				<!-- <div class="row my-4">
					<div class="col-12 col-lg">
						<label
							for="inputAddresse"
							class="form-label theme-main-color fw-bold"
							>Adresse</label
						>
						<span class="form-control-plaintext">{{
							employee.address.label
						}}</span>
					</div>
					<div *ngIf="employee.email" class="col-12 col-lg-6">
						<label for="email" class="form-label fw-bold">Email</label>
						<span class="form-control-plaintext" id="email">{{
							employee.email
						}}</span>
					</div>
				</div> -->
				<div class="row my-4">
					<!-- <div class="col-12 col-lg">
						<label for="birthDate" class="form-label fw-bold"
							>Date de naissance</label
						>
						<span class="form-control-plaintext">{{
							employee.birthDate | date: 'dd/MM/YYYY'
						}}</span>
					</div> -->
					<div class="col-12 col-lg-6">
						<label for="telephone" class="form-label fw-bold"
							>Numéro de téléphone</label
						>
						<span class="form-control-plaintext">{{ employee.telephone }}</span>
					</div>
					<div class="col-6">
						<label
							for="inputEmployeeType"
							class="form-label theme-main-color fw-bold"
							>Type d'employé</label
						>
						<span class="form-control-plaintext">{{
							EmployeeTypeStringEnum[employee.statutInt]
						}}</span>
					</div>
				</div>

				<div class="row my-4">
					<label for="expertises" class="form-label fw-bold"
						>Expertise(s)</label
					>
					<div class="row">
						<span class="col-12 col-lg text-dark">{{
							expertisesAsString()
						}}</span>
					</div>
				</div>

			</div>

		</div>

		<div class="row my-4">
			<div class="d-flex justify-content-lg-end justify-content-center">
				<button
					*ngIf="isFormReadOnly"
					class="btn theme-main-color-button"
					(click)="editForm()"
				>
					<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier les
					informations
				</button>
				<button
					*ngIf="!isFormReadOnly"
					class="btn theme-main-color-button mx-3 px-3"
					(click)="stopEditForm(false)"
				>
					Annuler
				</button>
				<button
					*ngIf="!isFormReadOnly"
					[disabled]="
						!employeeDetailForm.valid || isValidateButtonClicked.value
					"
					class="btn theme-green-button"
					type="submit"
					form="form"
				>
					<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
				</button>
			</div>
		</div>
	</div>
</div>

<ng-template #deleteEmployee>
	<div class="modal-header text-center">
		<h4>Suppression</h4>
		<button
			type="button"
			class="btn-close"
			data-bs-dismiss="modal"
			aria-label="Close"
			(click)="confirmDeleteModalRef.hide()"
		>
			<span aria-hidden="true"></span>
		</button>
	</div>
	<div class="modal-body">
		Êtes-vous sûr de vouloir effectuer la suppression ?
	</div>
	<div class="modal-footer">
		<a
			(click)="confirmDeleteModalRef.hide()"
			class="btn theme-main-color-button"
			>Retour</a
		>
		<a class="btn theme-red-button ms-3" (click)="delete(employee)"
			>Supprimer</a
		>
	</div>
</ng-template>
